import { render, staticRenderFns } from "./Price.html?vue&type=template&id=05afdcc6&scoped=true&"
import script from "./Price.js?vue&type=script&lang=js&"
export * from "./Price.js?vue&type=script&lang=js&"
import style0 from "./Price.scss?vue&type=style&index=0&id=05afdcc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05afdcc6",
  null
  
)

export default component.exports